import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import { Breadcrumbs } from "@material-ui/core";
const PackageSales = () => {
	//ApiData Component Content Variables
	const x = 0;
	const [positionID, setPositionID] = useState(get_cookies("position_id"));
	const [PackagesNavDetails, loadPackagesNav] = useState([]);
	const [contentNav, setContentNav] = useState("");
	const navigations = [];
	//OnLoad Event/Data Fetching
	useEffect(() => {
		get_package_navigation();
		getContentNavData();
	}, []);

	useEffect(() => {
		//
		isLoggedIn();
	}, [x]);

	//Api Functions SOF
	// const get_package_navigation = () => {
	// 	const formData = new FormData();
	// 	const form_data = {
	// 		jc_user_id_no: get_cookies('branchidno')
	// 	};
	// 	formData.append('form_data', JSON.stringify(form_data));
	// 	const apiUrl = process.env.REACT_APP_API_URL + "get_promocodeList";
	// 	axios.post(apiUrl, formData, {
	// 			headers:{
	// 				"Content-Type": "multipart/form-data",
	// 				'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL
	// 			}
	// 		} ).then(res => {
	// 		loadPackagesNav(res.data.packagesnav);
	// 	});

	// 	// axios.post(apiUrl, {form_data}).then(res => {
	// 	// loadPackagesNav(res.data.packagesnav);
	// // });

	// };
	const get_package_navigation = async () => {
		const result = await axios.get(process.env.REACT_APP_API_URL+'/get_promocodeList', {
			params:{
				jc_user_id_no: get_cookies('branchidno'),  //branchIdNo
			}
		}).then((res) => {
         
		      loadPackagesNav(res.data.data);
                      });
		
	}

	const getContentNavData = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "get_content_nav_data", {
				params: {
					name: "sales", //
					content_nav: get_cookies("content.nav.access")
				}
			})
			.then(function (res) {
				setContentNav(res.data.data);
			})
			.catch(function (error) {
				console.log(error);
			});
	};
	//Api Request Functions EOF
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
				<NavLink to="/sales">
						<h4 className="header-title">Sales</h4>
					</NavLink>
				<h4 className="header-title">Package Sales</h4>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<Grid container spacing={2}>
					{contentNav ? (
						contentNav.map(item => {
							return item.cn_hasline == -2 ? (
								<Grid
									item
									xs={6}
									className="app-card-container"
									key={item.id}
									style={{
										"--cardBorderColor": item.nav_color
									}}
								>
									<NavLink to={item.cn_url} key={item.id}>
										<div className="app-card">
											{item.cn_name}
										</div>
									</NavLink>
								</Grid>
							) : null;
						})
					) : (
						<div></div>
					)}
					{PackagesNavDetails.map((value, index) => {
						// <option value={key}>{tifs[key]}</option>
						navigations.push(
							<Grid
								item
								xs={6}
								className="app-card-container"
								style={{
									"--cardBorderColor": value.nav_color
								}}
							>
								<NavLink
									to={
										"/package-sales-setpackage/" +
										value.id +
										"/" +
										value.nav_name
									}
								>
									<div className="app-card">
										{value.nav_name}
									</div>
								</NavLink>
							</Grid>
						);
					})}
					{navigations}
				</Grid>
			</div>
		</div>
	);
};

export default PackageSales;
